export const tryCatch = async <T>(
   fn: () => Promise<T>,
   err?: () => void | Promise<void>,
   end?: () => void | Promise<void>
) => {
   let data: T | null = null
   let error: any = null

   try {
      data = await fn()
   } catch (e) {
      await err?.()
      error = e
   } finally {
      await end?.()
   }

   return { data, error }
}
